import $ from 'jquery';
$(window).on('load', function () {
    $('.preloader').addClass('complete');
});